import { Outlet } from 'react-router'
import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/redux/hooks'
import { useCountries } from '@/hooks/use-countries'
import { storeMenuQuery } from '@/hooks/use-store-menu'
import { storeProductsQuery } from '@/hooks/use-store-products'
import { usePages } from '@/hooks'
import { DEFAULT_COUNTRY_CODE } from '@/app/full-catalog/helpers/constants'
import { PortalHeader } from './portal-header'
import { PortalFooter } from './portal-footer'

export const PortalLayout = () => {
  const { i18n } = useTranslation()

  const { currentPage } = usePages()

  const group = useAppSelector(
    (store) => store.settingsApi.settings.response.ecommerce_group
  )

  const ecommerceId = useAppSelector(
    (store) => store.settingsApi.settings.response.ecommerce_id
  )

  const countryCode =
    useAppSelector((store) => store.return.returnAddress.country_code) ??
    DEFAULT_COUNTRY_CODE

  const orderCurrency = useAppSelector(
    (store) => store.returnsApi.order.response?.order?.money_format
  )?.currency

  const orderReference = useAppSelector(
    (store) =>
      store.returnsApi.order.response?.order?.identification
        ?.customer_printed_order_id
  )

  const exchangeFlow = useAppSelector(
    (store) => store.settingsApi.settings.response.exchange_flow
  )

  useCountries({
    ecommerceID: ecommerceId
  })

  const { isFetched: isMenuFetched, data: menu } = useQuery({
    ...storeMenuQuery({
      ecommerceId,
      language: i18n.language,
      countryCode,
      orderReference
    }),
    enabled: exchangeFlow === 'FULL'
  })

  useInfiniteQuery({
    ...storeProductsQuery({
      ecommerceId,
      language: i18n.language,
      countryCode,
      orderCurrency,
      resourceId: menu?.items?.[0] ? menu?.items?.[0].resource_id : undefined,
      resourceType: menu?.items?.[0]
        ? menu?.items?.[0].resource_type
        : undefined,
      orderReference
    }),
    enabled: exchangeFlow === 'FULL' && isMenuFetched
  })

  const isHoff = group === 'hoff'
  const isMisako = group === 'misako'

  return (
    <div className="flex h-dvh w-full flex-col">
      <PortalHeader />
      <Outlet />
      {currentPage === 'ItemSelection' ||
      currentPage === 'ItemOptions' ||
      isHoff ||
      isMisako ? null : (
        <div className="mt-auto flex items-center p-4 lg:bg-[#F2F2F2]">
          <PortalFooter />
        </div>
      )}
    </div>
  )
}
